import { render } from "./DocCheckBadge.vue?vue&type=template&id=f010b104&scoped=true"
import script from "./DocCheckBadge.vue?vue&type=script&lang=js"
export * from "./DocCheckBadge.vue?vue&type=script&lang=js"

import "./DocCheckBadge.vue?vue&type=style&index=0&id=f010b104&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f010b104"]])

export default __exports__